import React, { useState } from 'react';
// import { Helmet } from "react-helmet";
import './style.scss';
import { Link, useNavigate } from 'react-router-dom';
import { ManOutlined, WomanOutlined } from '@ant-design/icons';
import { Button, Input, Form } from 'antd';

type FieldType = {
  name?: string;
  phone?: number;
  dob?: string;
};

const MemberRegister: React.FC = () => {


  const navigate = useNavigate()

  const onFinish = (values: FieldType) => {
    navigate('/checkin-otp')
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const [isActiveGender, setActiveGender] = useState(1);

  return (
    <div className='checkin-page checkin-index'>
      <div className="bg-img">
        <img src="/images/checkin/bg-checkin-op1.jpg" alt="" />
      </div>
      <div className="content-block mw-708">
        <div className="title mb-24">Let's get started</div>

        <div className="sum">
          It looks like you are new here
        </div>

        <Form
          className="form-block"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
        >
          <div className="t-col-2 mb-24">
            <Form.Item<FieldType>
              label="Your name"
              name="name"
              rules={[{ required: true }]}
            >
              <div className="input-block">
                <Input placeholder="Your name" />
              </div>
            </Form.Item>

            <Form.Item<FieldType>
              label="Phone Number"
              name="phone"
              rules={[{ required: true }]}
            >
              <div className="input-block addon-after-input">
                <Input type="number" placeholder="Your phone number" />
              </div>
            </Form.Item>
          </div>

          <Form.Item<FieldType>
            label="DOB"
            name="dob"
            rules={[{ required: true, message: 'Your birthday, ex: 07/07/97' }]}
            className='mb-24'
          >
            <div className="input-block addon-after-input">
              <Input placeholder="Your birthday, ex: 07/07/97" />
            </div>
          </Form.Item>

          <div className="ctrl-group-gender mb-24">
            <div className="label">Sex</div>
            <div className="group-gender">
              <div className={`one-gender ${isActiveGender === 1 ? "active" : ""}`} onClick={() => setActiveGender(1)}>
                <div className="icon-svg"><ManOutlined /></div>
                <div className="text">Man</div>
              </div>
              <div className={`one-gender ${isActiveGender === 2 ? "active" : ""}`} onClick={() => setActiveGender(2)}>
                <div className="icon-svg"><WomanOutlined /></div>
                <div className="text">Woman</div>
              </div>
            </div>
          </div>

          <div className="btn-block ctrl-grid-2">
            <Link to="/check-login" className="btn btn-border-text-primary h-68">Cancel</Link>
            <Form.Item>
              <div className="mb-0">
                <Button className="btn t-btn-primary h-68" type="primary" htmlType="submit">
                  <div className="text">
                    Start Your Betting Journey!
                  </div>
                </Button>
              </div>
            </Form.Item>
          </div>
        </Form>

      </div>
    </div>
  );
}

export default MemberRegister;
